import React from "react"

export default function About(){
   return( 
   <div>
   <p className="About_Header">About</p>
   <p className="About">My passion for coding and web development has led me to take on various projects, honing my skills and gaining valuable experience in the field. 
    I am driven by my excitement for constantly learning and growing, and I am eager to bring my skills and passion to new and exciting opportunities.
    </p>
    </div>
   )

}